import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { LayoutDashboard, Building2, BookOpen, GraduationCap, Sparkles, UserCog, Send, Receipt, ShieldCheck, ShoppingBag, Tag, Users, Users2, Bot, Handshake, ClipboardCheck, Star, RotateCcw, Package, LifeBuoy, CreditCard, MessageSquare, LayoutTemplate, Zap, TrendingUp, Mail, BarChart3, UserCircle, Briefcase } from "lucide-react";

export default function StaffLayout({ user, superadmin, children }) {
  const base = superadmin ? "/app/superadmin" : "/app/staff";
  const nav = [
    { to: base, label: "Panel", icon: LayoutDashboard, end: true },
    { to: `${base}/reports`, label: "Reportería", icon: BarChart3 },
    { to: `${base}/tenants`, label: "Tenants / Partners", icon: Building2 },
    { to: `${base}/users`, label: "Usuarios", icon: UserCircle },
    { to: `${base}/integraciones`, label: "Integraciones", icon: Zap },
    { to: `${base}/catalogo`, label: "Catálogo", icon: BookOpen },
    { to: `${base}/catalogo/pendientes`, label: "Revisión editorial", icon: ClipboardCheck },
    { to: `${base}/paquetes`, label: "Paquetes", icon: Package },
    { to: `${base}/cohortes`, label: "Cohortes", icon: GraduationCap },
    { to: `${base}/tailor-made`, label: "Tailor-Made", icon: Sparkles },
    { to: `${base}/aliados`, label: "Aliados", icon: Handshake },
    { to: `${base}/afiliados`, label: "Afiliados", icon: Users2 },
    { to: `${base}/demo-requests`, label: "Demo requests", icon: Briefcase },
    { to: `${base}/codigos`, label: "Códigos", icon: Tag },
    { to: `${base}/ordenes`, label: "Órdenes", icon: ShoppingBag },
    { to: `${base}/order-bumps`, label: "Order Bumps", icon: Zap },
    { to: `${base}/upsells`, label: "Upsells", icon: TrendingUp },
    { to: `${base}/email/campaigns`, label: "Email marketing", icon: Mail },
    { to: `${base}/suscripciones`, label: "Suscripciones", icon: CreditCard },
    { to: `${base}/foros`, label: "Foros", icon: MessageSquare },
    { to: `${base}/partner-landings`, label: "Partner landings", icon: LayoutTemplate },
    { to: `${base}/reembolsos`, label: "Reembolsos", icon: RotateCcw },
    { to: `${base}/soporte`, label: "Soporte", icon: LifeBuoy },
    { to: `${base}/moderacion/reviews`, label: "Moderación reviews", icon: Star },
    { to: `${base}/descuentos`, label: "Descuentos", icon: Tag },
    { to: `${base}/equipo`, label: "Equipo", icon: Users },
    { to: `${base}/asistente`, label: "Asistente IA", icon: Bot },
    { to: `${base}/personal`, label: "Personal", icon: UserCog },
    { to: `${base}/comunicaciones`, label: "Comunicaciones", icon: Send },
    { to: `${base}/facturacion`, label: "Facturación", icon: Receipt },
    ...(superadmin ? [{ to: `${base}/auditoria`, label: "Auditoría", icon: ShieldCheck }] : []),
  ];
  return (
    <DashboardLayout title={superadmin ? "Superadmin" : "Staff DCC"} navItems={nav} tenantSlug="dcc">
      {children}
    </DashboardLayout>
  );
}
